import { useEffect, useRef, useState } from "react";
import { useT } from "../../features/i18n/useT";

export type OverflowItem = {
  label: string;
  onClick: () => void;
  danger?: boolean;
};

export function OverflowMenu({ items }: { items: OverflowItem[] }) {
  const t = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onDown = (e: MouseEvent) => {
      if (!open) return;
      const el = ref.current;
      if (!el) return;
      if (!el.contains(e.target as any)) setOpen(false);
    };
    return () => {
      window.removeEventListener("mousedown", onDown);
      window.removeEventListener("touchstart", onDown as any);
    };
  }, [open]);

  return (
    <div className="ov" ref={ref}>
      <button className={`ov-btn ${open ? "is-open" : ""}`} onClick={() => setOpen((v) => !v)} aria-label={t("common.menu")}>
        <span className="ov-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
      </button>

      {open ? (
        <div className="ov-panel" role="menu">
          {items.map((it, i) => (
            <button
              key={i}
              className={`ov-item ${it.danger ? "is-danger" : ""}`}
              role="menuitem"
              onClick={() => {
                setOpen(false);
                it.onClick();
              }}
            >
              {it.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}

